// extracted by mini-css-extract-plugin
module.exports = {"sectionWrap":"BanksSectionShow__sectionWrap--2a60S"};